import React, { FunctionComponent, useContext, useEffect, useState } from 'react';
import styles from "./Common.module.scss";
import { data } from './local';
import { Typography, CardHeader, CardMedia, CardContent, Button, Container, Tab, Tabs, Grid, Chip, Avatar, Card, Paper } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { getVideoURL } from './services';

const DashboardVideo: FunctionComponent<any> = ({ token }: any) => {
    const languageSelected: any = useSelector((state: any) => state.lang);
    const languageData: any = data;
    const { VIASection } = languageData[languageSelected];

    return (
        <Container maxWidth={"xl"} className={styles.VIASection}>
            {/* <Typography className={styles.VIAHeader} >{VIASection.title}</Typography> */}
            <Typography className={styles.VIASubheader} >{VIASection.subtitle}</Typography>
          
         
                    < div style={{  margin: '2', display: 'center', flexDirection: 'row', justifyContent: 'space-between', position: "relative" }}>
                        <span className={styles.header} style={{ display: "inline", float: "left" }}>

                            <Grid container className={styles.VIAimageSection} direction="row" justify="center" alignItems="center" >
                                <Grid>
                                    <img className={styles.VIAimage} src="/img/compassion.png" alt="" />
                                    <Typography className={styles.VIAimageCaption}>{VIASection.compassion}  </Typography>
                                </Grid>
                                <Grid>
                                    <img className={styles.VIAimage} src="/img/dignity.png" alt="" />
                                    <Typography className={styles.VIAimageCaption}> {VIASection.dignity}  </Typography>
                                </Grid>
                                <Grid>
                                    <img className={styles.VIAimage} src="/img/justice.png" alt="" />
                                    <Typography className={styles.VIAimageCaption}> {VIASection.justice}</Typography>
                                </Grid>


                            </Grid>

                            <Grid container className={styles.VIAimageSection} direction="row" justify="center" alignItems="center" >

                                <Grid>
                                    <img className={styles.VIAimage} src="/img/excellence.png" alt="" />
                                    <Typography className={styles.VIAimageCaption}> {VIASection.excellence}  </Typography>
                                </Grid>
                                <Grid>
                                    <img className={styles.VIAimage} src="/img/integrity.png" alt="" />
                                    <Typography className={styles.VIAimageCaption} >{VIASection.integrity} </Typography>
                                </Grid>
                            </Grid>
                        </span>
                        <span className={styles.header} style={{marginLeft:70,marginTop:60, display: "inline", float: "right" }}>
                            <Grid container className={styles.VIAimageSection} justifyContent="space-between" alignItems="center" spacing={4}>
                                <a href="https://vimeo.com/410723657/4567871159" target="_blank"> <img className={styles.VIAvideo} src="/img/0015.jpg" /></a>
                            </Grid>
                        </span>

                    </div>

           


        </Container>


    )
}

export default DashboardVideo